import React from 'react';
import { CalendarRange } from 'lucide-react';
import { FechaPicker } from './FechaPicker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { MESES } from './kpiUtils';
import { finDeMes, hoyArt, sumarDias, ultimosMeses } from './atencionUtils';

const MODOS = [
  { k: 'semana', l: 'Última semana' },
  { k: 'mes', l: 'Último mes' },
  { k: 'calendario', l: 'Mes calendario' },
  { k: 'rango', l: 'Rango' },
];

// B1: rango por fecha de creación. Devuelve {modo, mes, desde, hasta}.
export const rangoDe = (modo, mes, desde, hasta) => {
  const hoy = hoyArt();
  if (modo === 'semana') return { modo, mes, desde: sumarDias(hoy, -6), hasta: hoy };
  if (modo === 'mes') return { modo, mes, desde: sumarDias(hoy, -29), hasta: hoy };
  if (modo === 'calendario') return { modo, mes, desde: `${mes}-01`, hasta: finDeMes(mes) };
  return { modo, mes, desde: desde || sumarDias(hoy, -29), hasta: hasta || hoy };
};

const etiquetaMes = (ym) => `${MESES[Number(ym.slice(5)) - 1]} ${ym.slice(0, 4)}`;

export const AtencionFiltroFechas = ({ filtro, onChange }) => {
  const set = (cambios) => {
    const f = { ...filtro, ...cambios };
    onChange(rangoDe(f.modo, f.mes, f.desde, f.hasta));
  };
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3" data-testid="atencion-filtro">
      <CalendarRange className="h-4 w-4 text-sky-600" />
      <div className="flex flex-wrap gap-1 rounded-lg bg-slate-100 p-1">
        {MODOS.map((m) => (
          <button key={m.k} type="button" onClick={() => set({ modo: m.k })} data-testid={`atencion-filtro-${m.k}`}
            className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${filtro.modo === m.k ? 'bg-white text-sky-700 shadow-sm' : 'text-slate-600 hover:text-slate-900'}`}>
            {m.l}
          </button>
        ))}
      </div>
      {filtro.modo === 'calendario' && (
        <Select value={filtro.mes} onValueChange={(v) => set({ mes: v })}>
          <SelectTrigger className="h-9 w-44" data-testid="atencion-filtro-mes-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {ultimosMeses(18).map((ym) => <SelectItem key={ym} value={ym}>{etiquetaMes(ym)}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      {filtro.modo === 'rango' && (
        <div className="flex items-center gap-2">
          <FechaPicker value={filtro.desde} max={filtro.hasta} onChange={(v) => set({ desde: v })} testId="atencion-filtro-desde" />
          <span className="text-sm text-slate-400">a</span>
          <FechaPicker value={filtro.hasta} min={filtro.desde} onChange={(v) => set({ hasta: v })} testId="atencion-filtro-hasta" />
        </div>
      )}
      <span className="ml-auto text-xs text-slate-500" data-testid="atencion-filtro-texto">
        Creados del {filtro.desde.split('-').reverse().join('/')} al {filtro.hasta.split('-').reverse().join('/')} · hora Argentina
      </span>
    </div>
  );
};
